<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2020-11-13 14:50:49
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/mine/securitycheck/components/TopPer/index.vue
-->
<template>
  <div class="top_per text_left">
    <div class="font14 font_weight500 colo0 title_title">完成以下验证</div>
    <div class="font12 font_weight400 title_det det_color">
      单机“获取验证码”，系统会将短信验证码发送到
    </div>
    <div>
      <span class="font16 font_weight400 colo0">{{ getUserInfo.phone }}</span>
      <span class="font12 font_weight400 det_color"
        >的手机，请输入验证码完成验证。</span
      >
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    getUserInfo() {
      return this.$store.getters.getUserInfo;
    }
  }
};
</script>
<style lang="less" scoped>
.top_per {
  padding: 16px 12px 0;
  background: #fff;
  .det_color {
    color: rgba(0, 0, 0, 0.87);
  }
  .title_det {
    padding-top: 12px;
  }
  .det_det {
    padding-top: 9px;
  }
}
</style>
